import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createTimestampTransformer } from '../common/sql';
import {
  DBOutcomeTopicAssociationSchema,
  DBTopicGroupChildSchema,
  DBTopicGroupSchema,
  DBTopicGroupTopicSchema,
  DBTopicGroupingSchema,
  OutcomeTopicAssociationSchema,
  TopicGroupChildSchema,
  TopicGroupSchema,
  TopicGroupTopicSchema,
  TopicGroupingSchema,
} from './schemas';

export const TopicGroupingCodecConfig: TransformerConfig<
  typeof TopicGroupingSchema,
  typeof DBTopicGroupingSchema
> = {
  name: 'TopicGrouping',
  clientSchema: TopicGroupingSchema,
  dbSchema: DBTopicGroupingSchema,
  transformers: [
    createTimestampTransformer<typeof TopicGroupingSchema, typeof DBTopicGroupingSchema>(
      'createdAt'
    ),
    createTimestampTransformer<typeof TopicGroupingSchema, typeof DBTopicGroupingSchema>(
      'updatedAt',
      {
        nullable: true,
      }
    ),
  ],
};

export const TopicGroupCodecConfig: TransformerConfig<
  typeof TopicGroupSchema,
  typeof DBTopicGroupSchema
> = {
  name: 'TopicGroup',
  clientSchema: TopicGroupSchema,
  dbSchema: DBTopicGroupSchema,
  transformers: [
    createTimestampTransformer<typeof TopicGroupSchema, typeof DBTopicGroupSchema>('createdAt'),
    createTimestampTransformer<typeof TopicGroupSchema, typeof DBTopicGroupSchema>('updatedAt', {
      nullable: true,
    }),
  ],
};

export const TopicGroupChildCodecConfig: TransformerConfig<
  typeof TopicGroupChildSchema,
  typeof DBTopicGroupChildSchema
> = {
  name: 'TopicGroupChild',
  clientSchema: TopicGroupChildSchema,
  dbSchema: DBTopicGroupChildSchema,
  transformers: [
    createTimestampTransformer<typeof TopicGroupChildSchema, typeof DBTopicGroupChildSchema>(
      'createdAt'
    ),
  ],
};

export const TopicGroupTopicCodecConfig: TransformerConfig<
  typeof TopicGroupTopicSchema,
  typeof DBTopicGroupTopicSchema
> = {
  name: 'TopicGroupTopic',
  clientSchema: TopicGroupTopicSchema,
  dbSchema: DBTopicGroupTopicSchema,
  transformers: [
    createTimestampTransformer<typeof TopicGroupTopicSchema, typeof DBTopicGroupTopicSchema>(
      'createdAt'
    ),
  ],
};

export const OutcomeTopicAssociationCodecConfig: TransformerConfig<
  typeof OutcomeTopicAssociationSchema,
  typeof DBOutcomeTopicAssociationSchema
> = {
  name: 'OutcomeTopicAssociation',
  clientSchema: OutcomeTopicAssociationSchema,
  dbSchema: DBOutcomeTopicAssociationSchema,
  transformers: [
    createTimestampTransformer<
      typeof OutcomeTopicAssociationSchema,
      typeof DBOutcomeTopicAssociationSchema
    >('createdAt'),
  ],
};

export const encodeTopicGroupingToDb = createEncodeToDbFn(TopicGroupingCodecConfig);
export const decodeTopicGroupingFromDb = createDecodeFromDbFn(TopicGroupingCodecConfig);
export const encodeTopicGroupToDb = createEncodeToDbFn(TopicGroupCodecConfig);
export const decodeTopicGroupFromDb = createDecodeFromDbFn(TopicGroupCodecConfig);
export const encodeTopicGroupChildToDb = createEncodeToDbFn(TopicGroupChildCodecConfig);
export const decodeTopicGroupChildFromDb = createDecodeFromDbFn(TopicGroupChildCodecConfig);
export const encodeTopicGroupTopicToDb = createEncodeToDbFn(TopicGroupTopicCodecConfig);
export const decodeTopicGroupTopicFromDb = createDecodeFromDbFn(TopicGroupTopicCodecConfig);
export const encodeOutcomeTopicAssociationToDb = createEncodeToDbFn(
  OutcomeTopicAssociationCodecConfig
);
export const decodeOutcomeTopicAssociationFromDb = createDecodeFromDbFn(
  OutcomeTopicAssociationCodecConfig
);
